import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const livePulse = keyframes`
  0% {
    opacity: 0.45;
    transform: scale(0.8);
  }

  60% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0.45;
    transform: scale(0.8);
  }
`;

export const LivePulseIndicator = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.icon.emphasis};
  animation: ${livePulse} 1.4s ease-in-out infinite;
`;
